import { COMMAND_SCHEDULER_API_PATH } from "@/components/aios-command/chat/chat-constants";

export const SCHEDULED_JOBS_API_PATH = COMMAND_SCHEDULER_API_PATH;


export const SCHEDULED_JOB_FILTER_ALL = "all" as const;

export const SCHEDULED_JOB_ENTITY_TYPE_OPTIONS = [
  { label: "Command Agent", value: "command_agent" },
  { label: "Command Session", value: "command_session" },
  { label: "Sales Campaign", value: "sales_campaign" },
];


export function formatScheduledJobEntityTypeLabel(raw: string): string {
  const key = raw.trim().toLowerCase();
  const match = SCHEDULED_JOB_ENTITY_TYPE_OPTIONS.find((o) => o.value === key);
  if (match) return match.label;
  return raw
    .replace(/_/g, " ")
    .toLowerCase()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export const SCHEDULED_JOB_EXECUTION_STATUS_OPTIONS = [
  { label: "Due", value: "due" },
  { label: "Running", value: "running" },
  { label: "Completed", value: "completed" },
  { label: "Failed", value: "failed" },
];

export const SCHEDULED_JOB_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Expired", value: "expired" },
];


export type ScheduledJobExecutionBadgePalette = {
  color: string;
  bgColor: string;
  borderColor: string;
};

export const SCHEDULED_JOB_EXECUTION_STATUS_BADGE_COLORS = {
  completed: {
    color: "#166534",
    bgColor: "#DCFCE7",
    borderColor: "#BBF7D0",
  },
  failed: {
    color: "#991B1B",
    bgColor: "#FEE2E2",
    borderColor: "#FECACA",
  },
  /** Same palette as Integrations apps table `PENDING` (`bg-blue-100 text-blue-800 border-blue-200`). */
  running: {
    color: "#1E40AF",
    bgColor: "#DBEAFE",
    borderColor: "#BFDBFE",
  },
  /** Neutral grey chip for “due” / pending-style state. */
  due: {
    color: "#525252",
    bgColor: "#F5F5F5",
    borderColor: "#E5E5E5",
  },
} as const satisfies Record<string, ScheduledJobExecutionBadgePalette>;

/** Same neutral chip as `call-detail-card` `getStatusDisplay` default. */
export const SCHEDULED_JOB_EXECUTION_STATUS_BADGE_DEFAULT: ScheduledJobExecutionBadgePalette = {
  color: "#323232",
  bgColor: "#F5F5F5",
  borderColor: "#E0E0E0",
};

export type ScheduledJobExecutionStatusBadgeKey = keyof typeof SCHEDULED_JOB_EXECUTION_STATUS_BADGE_COLORS;

export const SCHEDULED_JOB_SORT_FIELDS = [
  "next_run_at",
  "created_at",
  "updated_at",
  "last_run_at",
  "run_count",
] as const;

export type ScheduledJobSortField = (typeof SCHEDULED_JOB_SORT_FIELDS)[number];
